module.exports = "void main(){\n  gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.);\n}\n";